import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/api";

const Loader = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-6">
    <img src={LOGO_URL} alt="Assietica Suite" className="h-16 w-auto object-contain animate-pulse" />
    <div className="h-5 w-5 rounded-full border-2 border-brand-blue border-t-transparent animate-spin" />
  </div>
);

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

// Guardia per-modulo: un utente non-admin può accedere solo alle rotte delle app
// che gli sono state assegnate. Blocca l'accesso via URL diretto agli altri moduli.
export const ModuleRoute = ({ children, moduleKey, section, internalOnly = false }) => {
  const { user, loading, apps, appsLoading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return children;
  if (appsLoading || apps === null) return <Loader />;

  const list = apps || [];
  let ok = false;
  if (moduleKey) {
    ok = list.some((a) => a.route === moduleKey);
  } else if (section) {
    ok = list.some((a) => (a.section || "operative") === section);
  } else if (internalOnly) {
    ok = list.some((a) => !a.benefit_ets);
  }
  if (!ok) return <Navigate to="/dashboard" replace />;
  return children;
};
